import React from 'react'
import Layout from '../../component/Layout';
import ExceptionContent from '../../component/ExceptionContent';
import { t } from 'i18next';

const ExceptionContainers = () => {
	return (
		<Layout title={t("exceptions")} description={t("exceptions_desc")}>
			<ExceptionContent />
		</Layout>
	)
}

export default ExceptionContainers;